import styled, { css } from "styled-components";

export const StyledButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  height: 35px;
  line-height: 35px;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #f3f1a5;
  font-size: 14px;
  font-family: "Reader Medium";
  color: #002B43;
  background: #fff;
  padding: 0 18px;
  border-radius: 20px;
  cursor: pointer;

  svg {
    width: 100%;
    height: 100%;
    filter: drop-shadow(0px 2px 2px #00000029);
  }

  &:hover {
    background: #f3f1a5;
    box-shadow: 0px 3px 6px #00000040;

    svg {
    filter: drop-shadow(0px 2px 2px #00000040);
  }
  }

  ${(props) =>
    props.img &&
    css`
      svg {
        display: none;
      }
    `}

  @media (min-width: 640px) {
    
    &:hover {
      ${(props) =>
        props.img &&
        css`
          svg {
            display: none;
          }
          .selected {
            display: block;
          }
        `}
    }
    ${(props) =>
      props.img &&
      css`
        background: none !important;
        border: none !important;
        box-shadow: none !important;
        padding: 0 2rem;
        margin-right: -0.125rem !important;

        svg {
          position: absolute;
          z-index: -1;
          top: 0;
          left: 0px;
          height: 100%;
          display: block;

          &.selected {
            display: none;
          }
        }
      `}

    ${(props) =>
      props.img && props.isActive &&
      css`
        svg {
          display: none;
        }
        svg.selected {
          display: block;
        }
      `}
  }

  ${(props) =>
    props.isActive &&
    css`
      background: #f3f1a5;
    `}

  ${(props) =>
    props.type === "dark" &&
    css`
      border-color: #b7e2fa;

      &:hover {
        background: #e7f4fc;
      }
    `}
  ${(props) =>
    props.type === "dark" &&
    props.isActive &&
    css`
      background: #e7f4fc;
    `}
`;
